import { Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { CustomViewOperator } from 'src/graphql/entities/custom-view/custom-view-config/operators';
import { FilterSection } from './styles';

interface OperatorSelectorProps {
  operators?: readonly CustomViewOperator[];
  operator?: CustomViewOperator;
  onChange: (op: CustomViewOperator) => void;
}

export const OperatorSelector = ({ operators, operator, onChange }: OperatorSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (opt: CustomViewOperator | null) => {
    if (opt) onChange(opt);
    setAnchorEl(null);
  };

  return (
    <>
      <FilterSection onClick={handleClick}>{operator?.display}</FilterSection>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose(null)}>
        {operators?.map((o) => (
          <MenuItem key={o.value} onClick={() => handleClose(o)}>
            {o.display}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
